/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PdfFile/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import SentryErrorBoundary from 'DesignSystem/SentryErrorBoundary/react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import styles from './view.module.css'
let PdfViewer = React.lazy(() => import('DesignSystem/PdfViewer/react'))



/** @type {import('Simple/types.js').View} */
export default function PdfFile({
  children,
  viewPath = "/DesignSystem/PreviewResource/Content/Content/PdfFile"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let resourcePreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource',
path: 'preview_url',
})
  return (<React.Fragment
>
<SentryErrorBoundary
  viewPath={`${viewPath}/SentryErrorBoundary`}
>
{childProps => (
<SuspenseBoundary
{...childProps}
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<div
  data-testid="PdfFile.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-17g1tE': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<PdfViewer
  viewPath={`${viewPath}/PdfViewer`}
 data="resource.preview_url"
 url={resourcePreviewUrlValueData}
/>
</div>
)}
</SuspenseBoundary>
)}
</SentryErrorBoundary>
{children}
</React.Fragment>)
}